export class ListingFilters {
  states: string[] = []

  constructor(states?: string[]) {
    if (states && Array.isArray(states)) {
      this.states = states
    }
  }
}

export class Preferences {
  listingFilters?: ListingFilters

  constructor(data?: any) {
    if (data?.listing_filters) {
      this.listingFilters = new ListingFilters(data?.listing_filters?.states)
    }
  }

  static fromJSON(json: any): Preferences {
    return new Preferences(json?.data ?? json)
  }
}
